<template>
  <div class="conference">
    <el-badge  style="height: 80px;margin-top: 55px;" value="hot" >
      <div> <p style="font-size: 34px;margin: 0;">热门会议</p> <p style="font-size: 24px;margin: 0">Hot meeting</p></div>
      <el-divider></el-divider>
    </el-badge>
    <el-row :gutter="45" style="width: 95%;margin: 50px auto 0">
      <el-col :offset="2"  :span="10" style="height: 300px">
        <div v-if="dataForm[0]" class="item" style="background-color: rgb(128,128,128);height: 100%;width: 100%;position: relative;overflow: hidden;">
          <img :src="'https://member.nfsoc.org.cn:8666'+dataForm[0].poster"  style="height: 100%;width: 100%;">
          <div class="shade">
            <p class="small_tit">{{dataForm[0].confName}}</p>
            <span class="info">
                <i class="el-icon-timer" width="20" height="20" style="margin-top: 25px"></i>{{dataForm[0].startTime}}
                <i class="el-icon-timer" width="20" height="20"></i>{{dataForm[0].venueAddress}}
            </span>
            <a style="cursor: pointer" @click="toSignUp(dataForm[0].confId)">To sign up</a>
          </div>
        </div>
      </el-col>
      <el-col  :span="10" style="height: 300px">
        <div v-if="dataForm[1]" class="item" style="background-color: rgb(128,128,128);height: 100%;width: 100%;position: relative;overflow: hidden">
          <img :src="'https://member.nfsoc.org.cn:8666'+dataForm[1].poster"  style="height: 100%;width: 100%;">
          <div class="shade">
            <p class="small_tit">{{dataForm[1].confName}}</p>
            <span class="info">
                <i class="el-icon-timer" width="20" height="20" style="margin-top: 25px"></i>{{dataForm[1].startTime}}
                <i class="el-icon-timer" width="20" height="20"></i>{{dataForm[1].venueAddress}}
            </span>
            <a style="cursor: pointer" @click="toSignUp(dataForm[1].confId)">To sign up</a>

          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="45" style="width: 95%;margin: 50px auto 0">
      <el-col :offset="3"  :span="6" style="height: 220px">
        <div v-if="dataForm[2]" class="item" style="background-color: rgb(128,128,128);height: 100%;width: 100%;position: relative;overflow: hidden">
          <img :src="'https://member.nfsoc.org.cn:8666'+dataForm[2].poster"  style="height: 100%;width: 100%;">
          <div class="shade">
            <p class="small_tit" style="font-size: 14px !important;">{{dataForm[2].confName}}</p>
            <span class="info" style="font-size: 14px">
                <i class="el-icon-timer" width="20" height="20" style="margin-top: 10px"></i>{{dataForm[2].startTime}}
                <i class="el-icon-timer" width="20" height="20"></i>{{dataForm[2].venueAddress}}
            </span>
            <a style="cursor: pointer" @click="toSignUp(dataForm[2].confId)">To sign up</a>

          </div>
        </div>
      </el-col>
      <el-col  :span="6" style="height: 220px">
        <div v-if="dataForm[3]" class="item" style="background-color: rgb(128,128,128);height: 100%;width: 100%;position: relative;overflow: hidden">
          <img  :src="'https://member.nfsoc.org.cn:8666'+dataForm[3].poster"  style="height: 100%;width: 100%;">
          <div class="shade">
            <p class="small_tit" style="font-size: 14px !important;">{{dataForm[3].confName}}</p>
            <span class="info" style="font-size: 14px">
                <i class="el-icon-timer" width="20" height="20" style="margin-top: 10px"></i>{{dataForm[3].startTime}}
                <i class="el-icon-timer" width="20" height="20"></i>{{dataForm[3].venueAddress}}
            </span>
            <a style="cursor: pointer" @click="toSignUp(dataForm[3].confId)">To sign up</a>

          </div>
        </div>
      </el-col>
      <el-col  :span="6" style="height: 220px">
        <div v-if="dataForm[4]" class="item" style="background-color: rgb(128,128,128);height: 100%;width: 100%;position: relative;overflow: hidden">
          <img  :src="'https://member.nfsoc.org.cn:8666'+dataForm[4].poster"  style="height: 100%;width: 100%;">
          <div class="shade">
            <p class="small_tit" style="font-size: 14px !important;">{{dataForm[4].confName}}</p>
            <span class="info" style="font-size: 14px">
                <i class="el-icon-timer" width="20" height="20" style="margin-top: 10px"></i>{{dataForm[4].startTime}}
                <i class="el-icon-timer" width="20" height="20"></i>{{dataForm[4].venueAddress}}
            </span>
            <a style="cursor: pointer" @click="toSignUp(dataForm[4].confId)">To sign up</a>

          </div>
        </div>
      </el-col>
    </el-row>
    <el-button style="margin-top: 45px;margin-left: 1050px;font-size: 16px;height: 35px;padding-top: 10px;" type="info" round @click="toMore">For more information<i class="el-icon-arrow-right el-icon--right"></i></el-button>
  </div>

</template>

<script>
export default {
name: "confenrence",
  data(){
    return{
      //热门会议
      dataForm:[],
      // type:'confenrence'
    }
  },
  methods:{
    toMore(){
      let routeData = this.$router.resolve({ path: '/more'});
      window.open(routeData.href, '_blank');
    },
    async getHotMeting(){
      const { data: res } = await this.$http.get('api/conference/confDetailed/user/hotListLimit5')
      // console.log(res,"会议");
      if(res.code === 200 ){
        this.dataForm =  res.data
      }else{
        this.$message.error(res.msg)
      }
    },
    async toSignUp(id){
      let routeData = this.$router.resolve({ path: '/signup',query:{id:id}
      // let routeData = this.$router.resolve({ path: '/login',query:{id:id}
      });
      window.open(routeData.href, '_blank');
    },
  },
  created() {
    this.getHotMeting()
  },
  mounted() {
    // this.getHotMeting()
  }
}
</script>

<style scoped lang="less">
.conference{
  background-color: #f2f2f2;
  color: #333;
  text-align: center;
  height: 900px;
}
.el-divider{
  background-color: red;
}
.shade{
  height: 100%;
  width: 100%;
  position: absolute;
  top: 80%;
  left: 0;
  right:0;
  background: rgba(0,0,0,.5);
  color: #fff;
  -webkit-transition:top 0.5s
}
.small_tit{
  font-size: 16px;
  -webkit-transition:margin-top 0.5s,font-size 0.5s;
}
.item:hover .shade{
  top:0;
}
.item:hover .small_tit{
  margin-top:80px;
  font-size: 22px;
}
.shade a {
  display: block;
  margin: 0 auto;
  width: 140px;
  height: 32px;
  background: #d61516;
  line-height: 32px;
  text-align: center;
  border-radius: 20px;
  font-size: 14px;
  margin-top: 35px;
  color: white;
}
.el-divider{
  margin: 10px 0;
}
</style>
